import h from 'hyperscript'
import data from '../data/services.yaml'

const id = document.getElementById.bind(document)
const params = new URLSearchParams(location.search)
const q = parseInt(params.get('q'))

if (isNaN(q)) {
  location = '/#hizmetler'
} else {
  id('app').appendChild(
    h('.section',
      h('.container',
        h('.columns',
          h('.column',
            h('.content.is-family-secondary',
              h('h1', data[q].title),
              h('p', data[q].text),
              h('ul',
                data[q].list.map(value =>
                  h('li', value)
                )
              )
            )
          ),
          h('.column#form-parent')
        )
      )
    )
  )

  id('form-parent').appendChild(id('form'))
  id('form').classList.remove('is-hidden')
  id('request').value = data[q].title
}
